const ApiUrl = 'https://ninolandia.goldpos.com.co/apiGold/';

const ApiRaiz = 'https://ninolandia.goldpos.com.co/';


const BackgroundColor = '#4175CB';


export { ApiUrl, BackgroundColor,ApiRaiz }
